import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, IconButton, Link, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';

import Info from './Info';
import RichText from '../../utils/RichText';

const inlineStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogTitle: {
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
  },
  iconContainer: {
    width: 'auto',
  },
  icon: {
    marginRight: '12px',
  },
  button: {
    verticalAlign: 'unset',
    width: 'auto',
  },
  requiredText: {
    paddingBottom: theme.spacing(2),
  },
});

const SSNDialog = ({ classes, t, content, helpText, showRequired }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Info>
      <div className={classes.container}>
        {showRequired && (
          <Typography variant="body1" className={classes.requiredText}>
            {t('views.appointmentLogin.helpInformation')}
          </Typography>
        )}
        <Typography variant="body1">
          {helpText} &nbsp;
          {content && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link variant="body1" component="button" type="button" onClick={handleClickOpen} className={classes.button}>
              {t('views.appointmentLogin.ssnReadMore')}
            </Link>
          )}
        </Typography>
      </div>

      {content && (
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle className={classes.dialogTitle}>
            <IconButton className={classes.closeButton} onClick={handleClose}>
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <RichText textData={content} />
          </DialogContent>
        </Dialog>
      )}
    </Info>
  );
};

SSNDialog.propTypes = {
  classes: PropTypes.object,
  content: PropTypes.object,
  helpText: PropTypes.string,
  showRequired: PropTypes.bool,
  t: PropTypes.func,
};

SSNDialog.defaultProps = {
  classes: {},
  content: {},
  helpText: '',
  showRequired: false,
  t: null,
};

export default withStyles(inlineStyles)(withTranslation('translations')(SSNDialog));
